import { render } from "./SuperFunds.vue?vue&type=template&id=2b8b5fe0&scoped=true"
import script from "./SuperFunds.vue?vue&type=script&lang=js"
export * from "./SuperFunds.vue?vue&type=script&lang=js"

import "./SuperFunds.vue?vue&type=style&index=0&id=2b8b5fe0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8b5fe0"]])

export default __exports__